import styled, { css } from 'styled-components'

const Container = styled.div`
  position: relative;
  width: 100%;

  margin: 0 auto;

  ${props =>
    props.sizing === 'small' &&
    css`
      max-width: 760px;
    `}

  ${props =>
    props.sizing === 'large' &&
    css`
      max-width: 1200px;
    `}
`

export default Container
